export default __webpack_public_path__ + "static/media/diar_ihza_resume.b8ac9ac8.pdf";